import React, { useEffect, useRef } from 'react';
import { message } from 'antd';
import E from 'wangeditor';
import apis from '@/apis';
import './index.less';
import AlertMenu from './components/alertMenu';

interface WangeditorForAcoreProps {
  // defaultValue?: ConclusionValue;
  value: string;
  onChange: any;
  placeholder?: string;
  height?: number;
  module?: any;
  disabled?: boolean;
}

function uploadImg(resultFiles: any, insertImgFn: any) {
  const file = resultFiles[0];
  const formData = new FormData();
  formData.append('file', file);
  apis.uploadPic &&
    apis
      .uploadPic(formData)
      .then((res: any) => {
        const { ret } = res;
        if (ret === '0' && res.data) {
          insertImgFn(res.data.urlList[0]);
        } else {
          message.error('上传图片失败，请稍后重试~');
        }
      })
      .catch((err: any) => {
        message.error(err);
      });
}

// function usePreValue(value: string) {
//   const refValue = useRef<string | null>(null);
//   useEffect(() => {
//     refValue.current = value;
//   }, [value]);

//   return [refValue.current];
// }

function WangeditorForAcore(props: WangeditorForAcoreProps, customUploadImg = null, customUploadVideo = null) {
  const { value = '', placeholder = '请输入正文', height = 300, module = -1, disabled = false } = props;
  const div = useRef<HTMLDivElement>(null);
  const editorRef = useRef<any>(null);
  const onContentChangeRef = useRef<(val: string) => any>(onContentChange);

  onContentChangeRef.current = onContentChange;

  function onContentChange(htmlText: string) {
    if (value === htmlText) return;
    props.onChange(htmlText);
  }

  useEffect(
    function () {
      if (!div.current) return;
      const menuKey = 'alertMenuKey';
      const editor = new E(div.current);
      editor.menus.extend(menuKey, AlertMenu);

      editor.config.focus = false;
      editor.config.zIndex = 1;
      editor.config.excludeMenus = ['indent', 'lineHeight', 'todo', 'quote', 'splitLine', 'table', 'code', 'emoticon'];
      editor.config.menus.splice(19, 0, menuKey);
      editor.config.showFullScreen = false;

      if (typeof customUploadImg === 'function') {
        editor.config.customUploadImg = customUploadImg;
      } else {
        editor.config.customUploadImg = uploadImg;
      }

      if (module !== -1) {
        // 自定义上传视频
        editor.config.customUploadVideo = function (files: any) {
          const imgURL = '//img30.360buyimg.com/pop/jfs/t1/172395/19/17641/5354/60de8daeE385cce06/7d3720f4862a9337.gif';
          editor.cmd.do('insertHTML', `<img id='loading' class='wangeditor-insert-loading' src='${imgURL}' />`);
          const formData = new FormData();
          formData.append('file', files[0]);
          formData.append('module', String(module));
          apis
            .fileUpload(formData)
            .then((res) => {
              if (res && res.ret === '0' && res.data) {
                document.getElementById('loading')?.remove();
                editor.cmd.do(
                  'insertHTML',
                  `<video controls style='max-height:300px;max-width:600px' class='insert-video' src="${res.data.urlList[0]}"></video>`
                );
              } else {
                document.getElementById('loading')?.remove();
                message.error('上传视频失败，请稍后重试~');
              }
            })
            .catch((err) => {
              document.getElementById('loading')?.remove();
              message.error(err);
            });
        };
        editor.config.uploadVideoMaxSize = 1 * 1024 * 1024 * 100; // 1024m
        editor.config.uploadVideoAccept = ['mp4'];
        editor.config.uploadVideoTimeout = 1000 * 60 * 50;
      }

      if (typeof customUploadVideo === 'function') {
        editor.config.customUploadVideo = customUploadVideo;
      }

      editor.config.placeholder = placeholder;
      editor.config.height = height;

      editor.config.onchange = function (newHtml: string) {
        onContentChangeRef.current(newHtml);
      };

      editor.create();

      if (disabled) editor.disable();

      editorRef.current = editor;

      return () => {
        editor.destroy();
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [placeholder, height, module, disabled]
  );

  useEffect(
    function () {
      if (!editorRef.current) return;
      if (value === editorRef.current.txt.html()) return;
      editorRef.current.txt.html(value);
    },
    [value]
  );

  return <div ref={div} />;
}

export default WangeditorForAcore;
